// eslint-disable-next-line import/no-unresolved,global-require,import/no-webpack-loader-syntax
export const loadMapboxGl = require('bundle-loader?lazy&name=mapboxgl!./mapbox');
// eslint-disable-next-line global-require,import/no-webpack-loader-syntax,import/no-unresolved
export const loadFlatpickr = require('bundle-loader?lazy&name=flatpickr!./flatpickr');
